import {BeforeYouGoPage} from '../../types/store/basket'

export const shouldShowPage = (productsCount: number, min: number) => productsCount >= min

export const predicate = (id: string, productIds: string[]) => !productIds.includes(id)

export const getValueIfDefined = (value: boolean | undefined) =>
  value !== undefined ? value : true

export const isSearchPage = (page: BeforeYouGoPage) => page.pageType === 'search'
